import { useContext } from 'react';
import { Stack, Flex } from '../../shared/layouts';
import Header from '../../shared/Header';
import { useQuery } from 'react-query';
import axios from 'axios';
import Loader from '../../shared/Loader';
import MessagebarContext from '../../../context/MessagebarContext';
import { useTranslation } from 'react-i18next';
import useIconLibrary from '../../../hooks/useIconLibrary';
import Button from '../../shared/Button';
import { useNavigate } from 'react-router-dom';
import AppointmentList from './components/AppointmentList';
import { useTheme } from '@emotion/react';
import { useMediaQuery } from '@dnhb/node_package';

const CalendarPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { breakpoints } = useTheme();
  const isMinTablet = useMediaQuery(
    `(min-width: ${breakpoints.tablet ?? '56.25rem'})`
  );
  const { setAlertMessage } = useContext(MessagebarContext);
  const { CalendarIcon } = useIconLibrary();

  const {
    isLoading,
    isFetchedAfterMount,
    refetch,
    data: appointmentsList = []
  } = useQuery('appointments', async () => {
    try {
      const { data } = await axios('/appointment');
      const appointmentsList = Object.values(data);

      return appointmentsList;
    } catch (error) {
      setAlertMessage();
    }
  });

  return (
    <>
      {(isLoading || !isFetchedAfterMount) && <Loader />}
      <Stack space="xl" width={{ sm: 656, ml: 672, lg: 800, xl: 1024 }}>
        <Header
          title={t('Mijn afspraken')}
          icon={<CalendarIcon height="2rem" width="2rem" />}
          variant="page"
        />
        {appointmentsList && <AppointmentList onRefresh={refetch} list={appointmentsList} />}
        <Flex justifyContent={'center'}>
          <Button
            variant={'primary-outline'}
            onClick={() => navigate('/calendar/new')}
            width={!isMinTablet ? '100%' : null}
          >
            {t('Plan afspraak')}
          </Button>
        </Flex>
      </Stack>
    </>
  );
};

export default CalendarPage;
